import { Component, Input } from '@angular/core';
import { Validators, NonNullableFormBuilder } from '@angular/forms';
import { BaseCustomerOfferRejectionCauses } from '../../../modules/inquiry/_const/base-customer-offer-rejection-causes.const';
import { BaseButtonSize, baseInquiryActions, BaseCoreState, InquiryOfferDeclineRequest } from 'base';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'base-customer-reject-offer-modal',
  templateUrl: './base-customer-reject-offer-modal.component.html',
})
export class BaseCustomerRejectOfferModalComponent {
  @Input() modalRef: NgbModalRef;
  @Input() inquiryId: number;
  @Input() offerId: number;
  @Input() fullName: string;

  rejectOfferForm = this.fb.group({
    decliningCategory: this.fb.control<{ label: string; id: string } | null>(null, {
      validators: [Validators.required],
    }),
    decliningNote: this.fb.control<string | null>(null),
  });

  isRejectFormSubmitted = false;

  rejectionCauseList = BaseCustomerOfferRejectionCauses;
  buttonSize = BaseButtonSize;

  constructor(
    private fb: NonNullableFormBuilder,
    private translate: TranslateService,
    private store: Store<BaseCoreState>
  ) {}

  rejectOffer(): void {
    this.isRejectFormSubmitted = true;

    if (this.rejectOfferForm.valid) {
      const { decliningNote, decliningCategory } = this.rejectOfferForm.getRawValue();

      const body: InquiryOfferDeclineRequest = {
        decliningNote: decliningNote || undefined,
        decliningCategory: decliningCategory ? this.translate.instant(decliningCategory.label) : '',
      };

      this.store.dispatch(
        baseInquiryActions.declineOfferCustomer({
          payload: { offer: this.offerId, inquiry: this.inquiryId, isCustomerOffersList: true, body },
        })
      );

      this.closeModal();
    }
  }

  closeModal(): void {
    this.modalRef.close();
  }
}
